module.exports = __webpack_public_path__ + "4dfddd3cd0c4623542ea82785142d28b.png";